var _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleIcon16P(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_492_180",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 17
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_492_180)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_492_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2418 8.68177C16.2418 8.1145 16.1907 7.56905 16.0958 7.04541H8.53149V10.1436H12.854C12.6641 11.14 12.0946 11.9836 11.2403 12.5509V14.5654H13.847C15.3657 13.169 16.2418 11.1181 16.2418 8.68177Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5316 16.5001C10.7001 16.5001 12.5182 15.7873 13.8471 14.5655L11.2404 12.551C10.5249 13.031 9.61222 13.3219 8.5316 13.3219C6.44339 13.3219 4.66913 11.9183 4.03391 10.0273H1.36157V12.0928C2.68314 14.7037 5.39197 16.5001 8.5316 16.5001Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.0339 10.02C3.87327 9.54001 3.77835 9.03091 3.77835 8.50001C3.77835 7.9691 3.87327 7.46001 4.0339 6.98001V4.91455H1.36157C0.813963 5.99091 0.5 7.20546 0.5 8.50001C0.5 9.79455 0.813963 11.0091 1.36157 12.0855L3.44249 10.4709L4.0339 10.02Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5316 3.68545C9.71444 3.68545 10.7658 4.09273 11.6055 4.87818L13.9055 2.58727C12.5109 1.29273 10.7001 0.5 8.5316 0.5C5.39197 0.5 2.68314 2.29636 1.36157 4.91455L4.0339 6.98C4.66913 5.08909 6.44338 3.68545 8.5316 3.68545Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_492_180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7419,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon16P);
export default __webpack_public_path__ + "static/media/google-icon-16p.b09a3563612716b54f77ad58c4cd4dbb.svg";
export { ForwardRef as ReactComponent };